export default __webpack_public_path__ + "static/media/handphone_2_without_words.c787c6cb.png";